/* cx: Kave-style arrows for the in-column "Combine it with" carousel.
   The complementary block loads async (product-recommendations fetch),
   so a MutationObserver enhances it whenever its list appears. */
(function () {
  'use strict';

  function arrowSvg(dir) {
    var d = dir === 'left' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function makeArrow(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cx-comp-arrow cx-comp-arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = arrowSvg(dir);
    return b;
  }

  function wireArrows(head, list) {
    if (head.__cxArrows) return;
    head.__cxArrows = true;

    var prev = makeArrow('left', 'Previous products');
    var next = makeArrow('right', 'Next products');

    function step() {
      var li = list.querySelector('li');
      return li ? li.getBoundingClientRect().width + 10 : 200;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });

    function sync() {
      var max = list.scrollWidth - list.clientWidth;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max - 2;
    }
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    var wrap = document.createElement('div');
    wrap.className = 'cx-comp-arrows';
    wrap.appendChild(prev);
    wrap.appendChild(next);
    head.appendChild(wrap);
    sync();
  }

  function enhance(comp) {
    var head = comp.querySelector('.summary__title');
    var list = comp.querySelector('ul.list-unstyled');
    if (!head || !list) return;
    wireArrows(head, list);
  }

  /* "You might be interested" + "Recently viewed": same heading/grid markup.
     Wrap the heading in a flex row, add arrows, tag the list for carousel CSS. */
  function enhanceSection(h2) {
    if (h2.__cxWrapped) return;
    var parent = h2.parentElement;
    var list = parent && parent.querySelector('ul.product-grid');
    if (!list || !list.children.length) return; /* recently-viewed fills async */
    h2.__cxWrapped = true;
    var row = document.createElement('div');
    row.className = 'cx-carousel-head';
    parent.insertBefore(row, h2);
    row.appendChild(h2);
    list.classList.add('cx-carousel');
    wireArrows(row, list);
  }

  function scan() {
    document.querySelectorAll('.complementary-products').forEach(function (c) {
      if (c.querySelector('ul.list-unstyled')) enhance(c);
    });
    document.querySelectorAll('h2.related-products__heading').forEach(enhanceSection);
  }

  if (typeof MutationObserver === 'function') {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') { scan(); } else { document.addEventListener('DOMContentLoaded', scan); }
})();
